import { render, staticRenderFns } from "./Donator.vue?vue&type=template&id=31434ff8&"
import script from "./Donator.vue?vue&type=script&lang=js&"
export * from "./Donator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Donator.vue"
export default component.exports